<div
  class="program {{ programCss }}"
  [ngClass]="[program === HEATING_SCHEDULE_LEVEL.Fixed ? '' : program]"
  [style.height.px]="calcHeight()"
  [class.dhw]="scheduleService.isDhwSchedule$ | async"
  [class.etp]="scheduleService.isETPSchedule$ | async"
>
  <ng-container *ngIf="duration >= 60">{{ start }}</ng-container>
</div>
